import * as List from "bs-platform/lib/es6/list.js";
import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Js_dict from "bs-platform/lib/es6/js_dict.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";

function $$char(c) {
  return $$String.make(1, c);
}

function date(d) {
  return d.toJSON();
}

function nullable(encode, param) {
  if (param !== undefined) {
    return Curry._1(encode, Caml_option.valFromOption(param));
  } else {
    return null;
  }
}

function withDefault(d, encode, param) {
  if (param !== undefined) {
    return Curry._1(encode, Caml_option.valFromOption(param));
  } else {
    return d;
  }
}

var object_ = Js_dict.fromList;
var array = $$Array.map;

function list(encode, l) {
  return $$Array.of_list(List.map(encode, l));
}

function pair(encodeA, encodeB, param) {
  return (
    /* array */
    [Curry._1(encodeA, param[0]), Curry._1(encodeB, param[1])]
  );
}

function tuple3(encodeA, encodeB, encodeC, param) {
  return (
    /* array */
    [Curry._1(encodeA, param[0]), Curry._1(encodeB, param[1]), Curry._1(encodeC, param[2])]
  );
}

function tuple4(encodeA, encodeB, encodeC, encodeD, param) {
  return (
    /* array */
    [Curry._1(encodeA, param[0]), Curry._1(encodeB, param[1]), Curry._1(encodeC, param[2]), Curry._1(encodeD, param[3])]
  );
}

var tuple2 = pair;
var arrayOf = array;
export { $$char, date, nullable, withDefault, pair, tuple2, tuple3, tuple4, object_, array, arrayOf, list };
/* No side effect */